// REACT
import { Outlet } from "react-router-dom";

// COMPONENTS
import Header from "../common/Header.js"

export default function PrimaryLayout(props) {
    return (
        <div>
            <Header />
            <main>
                <Outlet />
            </main>
        </div>
    );
}
